<mat-sidenav-container
  fullscreen
  autosize
  [hasBackdrop]="false"
  [ngClass]="{ 'sidenav-pinned sidenav-expanded': sidenavPinned() }">
  <mat-sidenav opened disableClose [mode]="sidenavPinned() ? 'side' : 'over'" [fixedInViewport]="true">
    <app-sidenav />
  </mat-sidenav>

  <mat-sidenav-content #matSidenavContent>
    <app-navbar id="app-navbar" class="position-sticky" />

    <router-outlet (activate)="onActivate()" />

    <app-file-download-notification />
  </mat-sidenav-content>
</mat-sidenav-container>

@if (isDataSaving()) {
  <div class="savingOverlay"></div>
}

<mat-sidenav-container (backdropClick)="onCloseNotifications()">
  <mat-sidenav
    class="notificationsSidenav"
    position="end"
    mode="over"
    autoFocus="false"
    [opened]="isNotificationsSidenavOpened()">
    <app-notifications-sidenav />
  </mat-sidenav>
</mat-sidenav-container>
